import { atom, useAtomValue } from 'jotai';
import { loadable, useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { checkIsPasswordSet } from 'services/api/account';

const passwordRefreshState = atom(0);

const isPasswordSetState = atom(async (get) => {
  get(passwordRefreshState);
  const rsp = await checkIsPasswordSet()
    .then((rsp) => rsp.data.data.isPasswordSet)
    .catch(() => {
      // do nothing
      return true;
    });
  return rsp;
});

export const useReCheckIsPasswordSet = () => {
  return useAtomCallback(
    useCallback(async (get, set) => {
      const isPasswordSet = await get(isPasswordSetState);
      // 一次性属性，只要设置过为true后就不会改变，此时可以跳过forceupdate.
      if (isPasswordSet) {
        return isPasswordSet;
      }
      set(passwordRefreshState, (n) => n + 1);
    }, []),
  );
};

const useIsPasswordSet = () => {
  const value = useAtomValue(loadable(isPasswordSetState));
  return value.state === 'hasData' ? value.data : false;
};

export default useIsPasswordSet;
